'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _WidgetRenderer = require('./WidgetRenderer');

var _WidgetRenderer2 = _interopRequireDefault(_WidgetRenderer);

var _utilsBindToSchema = require('./utils/bindToSchema');

var _utilsBindToSchema2 = _interopRequireDefault(_utilsBindToSchema);

var _ContainerRendererJs = require('./ContainerRenderer.js');

var _ContainerRendererJs2 = _interopRequireDefault(_ContainerRendererJs);

var HtmlPagesRenderer = (function (_React$Component) {
	_inherits(HtmlPagesRenderer, _React$Component);

	function HtmlPagesRenderer() {
		_classCallCheck(this, HtmlPagesRenderer);

		_get(Object.getPrototypeOf(HtmlPagesRenderer.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(HtmlPagesRenderer, [{
		key: 'render',
		value: function render() {
			var schema = this.props.schema;
			var dataContext = this.props.dataContext;
			var widgets = this.props.widgets;

			var bindSchema = (0, _utilsBindToSchema2['default'])(schema, dataContext);

			var isGrid = schema.containers[0] && schema.containers[0].elementName === "Grid";

			var ctx = schema.props && schema.props.context || {};
			var customStyles = ctx['styles'] || {};

			var code = ctx['code'] && ctx['code'].compiled;
			//TODO: hacky way how to compile
			if (code !== undefined) code = code.substr(code.indexOf('return')).replace('})();', '');

			//console.log(code);
			var customCode = !!code ? new Function(code)() : undefined;

			//append shared code to data context
			if (dataContext !== undefined) dataContext.customCode = customCode;

			var pageBackground = schema.props && schema.props.background || {};

			var pagesRoot = this.props.pagesRoot || 'div';

			var containerRenderer = _react2['default'].createElement(_ContainerRendererJs2['default'], { elementName: bindSchema.elementName,
				containers: bindSchema.containers,
				node: bindSchema,
				boxes: bindSchema.boxes,
				dataBinder: dataContext,
				ctx: ctx,
				widgets: widgets,
				widgetRenderer: _WidgetRenderer2['default']
			});

			return _react2['default'].createElement(pagesRoot, { className: 'printable', id: "section-to-print", style: this.props.style }, containerRenderer);
		}
	}]);

	return HtmlPagesRenderer;
})(_react2['default'].Component);

exports['default'] = HtmlPagesRenderer;
;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-html-pages-renderer/lib/HtmlRenderer.js
 ** module id = 1223
 ** module chunks = 0
 **/